import React, { FC } from 'react'
import {
    FormSelect,
    FormSelectProps,
} from '@docpace/shared-react-components/FormSelect'
import { PracticeSlugFragment } from '@docpace/shared-graphql/fragments'
import { useFormContext } from 'react-hook-form'

interface MuiFormPracticeSlugSelectProps extends Omit<FormSelectProps, 'options'> {
    formController?: any
    practiceSlugs: PracticeSlugFragment[]
    label?: string
}

export const MuiFormPracticeSlugSelect: FC<MuiFormPracticeSlugSelectProps> = ({
    formController,
    practiceSlugs,
    ...selectProps
}) => {
    const formContext = useFormContext()
    const {
        formState: { errors },
    } = formContext
    return (
        <FormSelect {...selectProps} options={[
            { value: '', label: 'none' },
            ...practiceSlugs?.length > 0 ? practiceSlugs.map(slug=>({
                label: slug?.slug,
                value: slug?.practiceSlugId
            })): []
        ]} />
    )
}

export default MuiFormPracticeSlugSelect
